import { render, staticRenderFns } from "./newlabels.vue?vue&type=template&id=25eae919&scoped=true&lang=html&"
import script from "./newlabels.vue?vue&type=script&lang=js&"
export * from "./newlabels.vue?vue&type=script&lang=js&"
import style0 from "./newlabels.vue?vue&type=style&index=0&id=25eae919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eae919",
  null
  
)

export default component.exports